import React from "react";
import { Dropdown, Menu } from "antd";
import { withRouter } from "react-router";
import { FormattedMessage } from "react-intl";
import DownOutlined from "@ant-design/icons/lib/icons/DownOutlined";
import { Link } from "react-router-dom";

const BaseLanguageSelectorMenu = ({
  match: {
    params: {
      locale
    }
  },
  location
}) => {
  const locales = [{
    locale: "ar",
    id: "shared.arabic"
  }, {
    locale: "en",
    id: "shared.english"
  }];
  const selectedLocale = locales.find(item => item.locale !== (locale || "en"));
  const menuItems = locales.map(item => React.createElement(Menu.Item, {
    key: item.id
  }, React.createElement(Link, {
    to: `/${item.locale}${location.pathname.slice(3)}`
  }, React.createElement(FormattedMessage, {
    id: item.id
  }))));
  return React.createElement(Dropdown, {
    overlay: React.createElement(Menu, null, menuItems)
  }, React.createElement(Link, {
    className: "ant-dropdown-link",
    to: `/${selectedLocale.locale}${location.pathname.slice(3)}`
  }, React.createElement(FormattedMessage, {
    id: selectedLocale.id
  }), " ", React.createElement(DownOutlined, null)));
};

export const LanguageSelectorMenu = withRouter(BaseLanguageSelectorMenu);